import { useFormContext } from 'react-hook-form';

import type { FormNumberInputProps } from '@/_components';
import { FormField, FormNumberInput } from '@/_components';

type PercentageInputProps = FormNumberInputProps & {
  isEditable?: boolean;
  name: string;
  isNegativeAllowed?: boolean;
};

export const FormPercentageInput = ({ ref, isEditable, name, onValueChange, ...rest }: PercentageInputProps) => {
  const form = useFormContext();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field: { value, onChange } }) => (
        <FormNumberInput
          ref={ref}
          {...rest}
          disabled={!isEditable}
          suffix="%"
          thousandSeparator
          decimalScale={2}
          valueIsNumericString
          fixedDecimalScale
          isAllowed={(val) => {
            const floatValue = val.floatValue ?? 0;
            return floatValue >= 0 && floatValue <= 100;
          }}
          value={value}
          onValueChange={(s, v) => {
            onChange(`${s?.floatValue ?? 0}`);
            onValueChange?.(s, v);
          }}
        />
      )}
    />
  );
};
